import makeValidationSchema from './BillOfLadingMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import AceOcnPermitToTransferKeys from 'src/constants/locale/key/AceOcnPermitToTransfer'
import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
} from 'cng-web-lib'
import {FirmCodesAutocompleteField} from 'src/components/na'
import { useFormContext } from "react-hook-form";

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  billNumber: "",
  firmsCode: "",
  bondedCarrierType: "",
  bondedCarrier: "",
  containerNumber: "",
  quantity: "",
  remarks: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap,
  portOfDischarge 
}) {
  const { translate } = useTranslation(Namespace.P_T_T_SAMPLE_J_S_O_N_F_O_R_D_T_O)
  const translatedTextsObject = makeTranslatedTextsObject()
  const {watch} = useFormContext()
  const firmsCode=watch('firmsCode')

  function makeTranslatedTextsObject() {
    let billOfLading = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.TITLE
    )
    let billNumber = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.BILL_OF_LADING_NUMBER
    )
    let firmsCode = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.FIRMS_CODE
    )
    let bondedCarrierType = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER_TYPE
    )
    let bondedCarrier = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER
    )
    let containerNumber = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.CONTAINER_NUMBER
    )
    let quantity = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.QUANTITY
    )
    let remarks = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.REMARKS
    )

    return {
      billOfLading,
      billNumber,
      firmsCode,
      bondedCarrierType,
      bondedCarrier,
      containerNumber,
      quantity,
      remarks
    }
  }

	return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.billOfLading} />
      <CardContent>
        <Grid container spacing={3}>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.billNumber}>
            <CngTextField
              name="billNumber"
              label={translatedTextsObject.billNumber}
              disabled={disabled}
              size='small'
              required
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.firmsCode}>
            <FirmCodesAutocompleteField
              name="firmsCode"
              label={translatedTextsObject.firmsCode}
              disabled={disabled}
              size='small'
              portCode={portOfDischarge}
              key={firmsCode+portOfDischarge}
              required
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.bondedCarrierType}>
            <CngCodeMasterAutocompleteField
              name="bondedCarrierType"
              label={translatedTextsObject.bondedCarrierType}
              disabled={disabled}
              size='small'
              required
              codeType='ACEOCN_PTT_BONDED_CARRIER_TYPE'
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.bondedCarrier}>
            <CngTextField
              name="bondedCarrier"
              label={translatedTextsObject.bondedCarrier}
              disabled={disabled}
              size='small'
              required
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.containerNumber}>
            <CngTextField
              name="containerNumber"
              label={translatedTextsObject.containerNumber}
              disabled={disabled}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.quantity}>
            <CngTextField
              name="quantity"
              label={translatedTextsObject.quantity}
              disabled={disabled}
              size='small'
              required
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.remarks}>
            <CngTextField
              name="remarks"
              label={translatedTextsObject.remarks}
              disabled={disabled}
            />
          </CngGridItem>
        </Grid>
      </CardContent>
    </Card>
	)
}

const BillOfLadingFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default BillOfLadingFormProperties
